import React from 'react'
import { FlexContainerCentered } from '../../Components'

export default (props) => {
    return (
        <FlexContainerCentered>
            Please wait while we fetch the media
        </FlexContainerCentered>
    )
}
